<template>

  <div class="section-banner" :class="classBanner">
    <div class="section-banner__title">
      <!--<img v-if="!title" class="" src="@/assets/images/header/banners-desktop.jpg"/>-->
      <!--<img v-if="title" class="" src="@/assets/images/header/header-banner.png"/>-->
      {{ title }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    classBanner: {
      type: String,
      default: ''
    },
  }
}
</script>
